import { modes } from "../modes";
import { roles } from "../roles";

export const mobilePermissionProfiles = {
    VIEW_ACTIVITY: {
        [modes.EDIT]: [roles.OWNER],
    },
  
}